import { CopyIcon, SupportIcon } from '@weblite/icons'
import { copyToClipboard } from '@weblite/logic-toolkit'
import { Link, Typography, styled } from '@mui/material'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { PrimaryButton } from '$common/buttons'
import { BottomDrawer } from '$common/bottom-drawer'
import { t } from '$i18n'
import { showTextSavedInMemorySnackbar } from '$comp/snackbars'
import { PrimaryOutlinedButton } from '$common/buttons/primary-outlined-button'

export interface Props {
  isOpen?: boolean
}

const TELEGRAM_SUPPORT_ACCOUNT_ID = import.meta.env
  .VITE_TELEGRAM_SUPPORT_ACCOUNT_ID

const supportAccountLink = `https://t.me/${TELEGRAM_SUPPORT_ACCOUNT_ID}`

export function Support({ isOpen }: Props) {
  const handleCopyToClipboard = () => {
    copyToClipboard(`@${TELEGRAM_SUPPORT_ACCOUNT_ID}`).then(async () => {
      await closeCurrentModal()
      showTextSavedInMemorySnackbar()
    })
  }
  return (
    <BottomDrawer isOpen={!!isOpen} onClose={closeCurrentModal}>
      <Root>
        <IconContainer>
          <SupportIcon />
        </IconContainer>

        <Content>
          <Typography
            dir="auto"
            variant="paragraph1"
            sx={{
              overflowWrap: 'break-word',
              wordWrap: 'break-word',
              wordBreak: 'break-word',
              whiteSpace: 'pre-wrap',
              textAlign: 'right',
            }}
          >
            {t('supportModal.description')}
          </Typography>
          <Link
            sx={{ textAlign: 'left' }}
            href={supportAccountLink}
            target="_blank"
          >
            @{TELEGRAM_SUPPORT_ACCOUNT_ID}
          </Link>
        </Content>

        <Actions>
          <PrimaryButton
            fullWidth
            text={t('supportModal.confirmText')}
            onClick={closeCurrentModal}
          />
          <PrimaryOutlinedButton
            fullWidth
            text={t('supportModal.copy')}
            onClick={handleCopyToClipboard}
            startIcon={<CopyIcon />}
          />
        </Actions>
      </Root>
    </BottomDrawer>
  )
}

const Root = styled('div')`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 32px 20px 28px;
  align-items: center;
  gap: 20px;
`

const Content = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Actions = styled('div')`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
`

const IconContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.success100};

  & > svg {
    width: 64px;
    height: 64px;
    color: ${({ theme }) => theme.palette.success500};
  }
`
